/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export default class SceneBase extends THREE.Scene {
  constructor(props) {
    super(props);
    this.bb = new THREE.Box3();
    this.model = new THREE.Object3D();
    this.isLoaded = false;
  }

  setRenderer = renderer => {
    this.renderer = renderer;
  };

  setCanvas = canvas => {
    this.canvas = canvas;
  };

  loaded = () => {
    this.isLoaded = true;
    this.dispatchEvent({ type: 'contentLoaded', object: this });
  };

  setup = props => {
    this.loaded();
  };

  update = time => {};
  render = () => {};
  resize = event => {};

  enter = (duration, delay, cb) => {
    // you have to call the callbacks at somepoint or else the app will hang
    if (cb) {
      cb();
    }
  };

  exit = (duration, delay, cb) => {
    // you have to call the callbacks at somepoint or else the app will hang
    if (cb) {
      cb();
    }
  };

  reset = () => {
    this.position.set(0, 0, 0);
    this.model.rotation.set(0, 0, 0);
    this.model.updateMatrixWorld(true);
    this.updateMatrixWorld(true);
    this.dispatchEvent({ type: 'reset', object: this });
  };

  enterAR = (duration, delay, cb) => {
    // you have to call the callbacks at somepoint or else the app will hang
    if (cb) {
      cb();
    }
  };

  exitAR = (duration, delay, cb) => {
    // you have to call the callbacks at somepoint or else the app will hang
    if (cb) {
      cb();
    }
  };

  getBoundingBox = () => {
    return this.bb;
  };

  getModel = () => {
    return this.model;
  };
}



// WEBPACK FOOTER //
// ./src/scenes/BaseScene.js